/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";

function subtractHours(date: any) {
  date.setHours(date.getHours() - 720);
  return date;
}

const dateNow = new Date();
const dateTime = subtractHours(dateNow);

export const getAllExpressions = () => {
  return progressApi.get("/ExpMeta/GetAllExpressions");
};

export const getExpressionByUnit = (id: any) => {
  return progressApi.get(`/ExpMeta/GetExpressionByUnit?id=${id}`);
};

export const getExpressionByEquipment = (id: any) => {
  return progressApi.get(`/ExpMeta/GetExpressionByEquipment?id=${id}`);
};

export const getExpressionById = (id: any) => {
  return progressApi.get(`/ExpMeta/GetExpression?id=${id}`);
};

export const getExpressionData = (
  ids: any,
  dateTime?: string
) => {
  let url = "Dashboard/GetExpData";
  dateTime ? (url += `?dateTime=${dateTime}`) : null;
  return progressApi.post(url, ids);
};

export const createExpression = (expression: any) => {
  return progressApi.post("/ExpMeta/CreateExpression", expression);
};

export const updateExpression = (expression: any) => {
  return progressApi.post("/ExpMeta/UpdateExpression", expression);
};

export const deleteExpression = (id: any) => {
  return progressApi.get(`/ExpMeta/DeleteExpression?id=${id}`);
};

export const validateExpression = (expression: any) => {
  return progressApi.post("/ExpMeta/ValidateExpression", expression);
};
